"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const actions_1 = require("../app/actions/actions");
const DynamicWhitelist_1 = require("../utils/DynamicWhitelist");
const INIT_STATE = {
    columnSelectionS22: {
        selectedCategoricalColumns: [],
        selectedNumericalColumns: [],
        selectedTargetColumn: [],
        selectedDateTime: "",
        remainingColumns: [],
        lagVariablesColumnList: [],
        selectedDropColumns: [],
        selectedIndexColumns: [],
        warning: "",
    },
    columnSelectionS32: {
        selectedLabelEncoding: [],
        selectedOnehotEncoding: [],
        selectedMinMaxScaler: "",
        selectedStandardScaler: "",
        remainingColumns: [],
        anomalyFeatureColumnOperation: "",
        anomalyTargetColumnOperation: "",
    },
    nullValueColumns: {
        nullValueColumns: [],
    },
    samplingMethod: {
        samplingMethod: "undersampling",
    },
    trainTestRatio: 80,
    featureSelections: {
        featureselection_method: "manualselection",
        featurecolumns: [],
        featureSelectionTargetColumns: [],
        featureSelectionDateTimeColumns: [],
        threshold: 0,
        k: 0,
    },
    binary_thresholding: {
        categorical: {},
        numerical: {},
    },
    feature_mapping_data: {
        rename_columns: {},
        drop_columns: []
    },
    finalUniqueColumns: [],
    dataTransform: {
        algorithm: "",
        domain_knowledge_method: "",
        domain_knowledge: {
            root_nodes: [],
            leaf_nodes: [],
            forbids: [],
            requires: []
        },
        selected_yaml_file: null
    },
    model_selection: {
        method: "",
        event_column: ""
    },
    graph_path: ""
};
exports.default = (state = INIT_STATE, action) => {
    const initialKeys = Object.keys(INIT_STATE);
    switch (action.type) {
        case actions_1.SAVE_COLUMN_SELECTIONS22: {
            return Object.assign({}, state, { selectedCategoricalColumns: action.payload.selectedCategoricalColumns, selectedNumericalColumns: action.payload.selectedNumericalColumns, selectedTargetColumn: action.payload.selectedTargetColumn, selectedDateTime: action.payload.selectedDateTime, remainingColumns: action.payload.remainingColumns, lagVariablesColumnList: action.payload.lagVariablesColumnList, selectedIndexColumns: action.payload.selectedIndexColumns, selectedDropColumns: action.payload.selectedDropColumns, warning: action.payload.warning });
        }
        case actions_1.SAVE_COLUMN_SELECTIONS32: {
            return Object.assign({}, state, { selectedLabelEncoding: action.payload.selectedLabelEncoding, selectedOnehotEncoding: action.payload.selectedOnehotEncoding, selectedMinMaxScaler: action.payload.selectedMinMaxScaler, selectedStandardScaler: action.payload.selectedStandardScaler, remainingColumns: action.payload.remainingColumns, anomalyFeatureColumnOperation: action.payload.anomalyFeatureColumnOperation, anomalyTargetColumnOperation: action.payload.anomalyTargetColumnOperation });
        }
        case actions_1.NULL_VALUE_COLUMNS: {
            return Object.assign({}, state, { nullValueColumns: action.payload });
        }
        case actions_1.SAVE_FEATURE_SELECTIONS: {
            return Object.assign({}, state, { featureselection_method: action.payload.featureselection_method, featurecolumns: action.payload.featurecolumns, featureSelectionTargetColumns: action.payload.featureSelectionTargetColumns, threshold: action.payload.threshold, k: action.payload.k, featureSelectionRemainingColumns: action.payload.featureSelectionRemainingColumns });
        }
        case actions_1.SAVE_SAMPLING_METHOD: {
            return Object.assign({}, state, { samplingMethod: action.payload });
        }
        case actions_1.SAVE_TRAIN_TEST_RATIO: {
            return Object.assign({}, state, { trainTestRatio: action.payload });
        }
        case actions_1.UPDATE_BINARY_THRESHOLDING_DATA: {
            const categorical = action.payload.categorical;
            const numerical = action.payload.numerical;
            return Object.assign({}, state, { binary_thresholding: {
                    categorical: categorical,
                    numerical: numerical
                } });
        }
        case actions_1.FEATURE_MAPPING_DATA: {
            const rename_columns = action.payload.rename_columns;
            const drop_columns = action.payload.drop_columns;
            return Object.assign({}, state, { feature_mapping_data: Object.assign({}, state.feature_mapping_data, { rename_columns: rename_columns, drop_columns: drop_columns }) });
        }
        case actions_1.SAVE_FINAL_UNIQUE_COLUMNS: {
            return Object.assign({}, state, { finalUniqueColumns: action.payload });
        }
        case actions_1.SAVE_DATA_TRANSFORM_RSA_MS: {
            const method = action.payload.algorithm;
            const domainKnowledgeMethod = action.payload.domain_knowledge_method;
            const domainKnowledge = action.payload.domain_knowledge;
            const file = action.payload.selected_yaml_file;
            return Object.assign({}, state, { dataTransform: {
                    algorithm: method,
                    domain_knowledge_method: domainKnowledgeMethod,
                    domain_knowledge: domainKnowledge,
                    selected_yaml_file: file
                } });
        }
        case actions_1.SAVE_MODEL_SELECTION: {
            const method = action.payload.method;
            const eventColumn = action.payload.event_column;
            return Object.assign({}, state, { model_selection: {
                    method: method,
                    event_column: eventColumn
                } });
        }
        case actions_1.SAVE_GRAPH_PATH: {
            return Object.assign({}, state, { graph_path: action.payload });
        }
        case actions_1.RESET_UNWHITELISTED_STATE: {
            const { whitelist } = DynamicWhitelist_1.DynamicWhitelist();
            const resetState = {};
            initialKeys.forEach((key) => {
                if (!whitelist.includes(key)) {
                    resetState[key] = INIT_STATE[key];
                }
            });
            return Object.assign({}, state, resetState);
        }
        default:
            return state;
    }
};
//# sourceMappingURL=column-selection.js.map